/* TEMPERED STATE — Shopify theme interactions (home layout) */
(() => {
  const TS = window.TS || { routes: {} };
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fmt = new Intl.NumberFormat(TS.locale || 'en-US', { style: 'currency', currency: TS.currency || 'USD' });
  const money = (cents) => fmt.format((cents || 0) / 100);

  /* ---------- Garment silhouettes (collection tiles / no-photo fallback) ---------- */
  const GARMENTS = {
    tee: {
      body: 'M62 22 L82 12 Q100 28 118 12 L138 22 L184 52 L166 88 L148 77 L148 226 L52 226 L52 77 L34 88 L16 52 Z',
      lines: 'M82 12 Q100 34 118 12',
      print: { px: '50%', py: '30%', pw: '15%' },
    },
    hoodie: {
      body: 'M72 32 Q70 6 100 4 Q130 6 128 32 L150 38 L178 72 L192 202 L168 206 L156 100 L152 228 L48 228 L44 100 L32 206 L8 202 L22 72 L50 38 Z',
      lines: 'M80 34 Q100 56 120 34 M70 170 L130 170 L136 206 L64 206 Z M48 214 L152 214',
      print: { px: '50%', py: '32%', pw: '14%' },
    },
    shorts: {
      body: 'M44 46 L156 46 L170 192 L110 198 L100 112 L90 198 L30 192 Z',
      lines: 'M44 60 L156 60 M100 60 L100 112',
      print: { px: '33%', py: '62%', pw: '9%' },
    },
    joggers: {
      body: 'M58 12 L142 12 L152 226 L112 230 L102 72 L98 72 L88 230 L48 226 Z',
      lines: 'M58 26 L142 26 M50 212 L90 214 M110 214 L150 212',
      print: { px: '36%', py: '30%', pw: '8%' },
    },
  };
  function garmentHTML(type, withPrint = true) {
    const g = GARMENTS[type] || GARMENTS.tee;
    const p = g.print;
    return `
      <div class="garment">
        <div class="garment__fig">
          <svg viewBox="0 0 200 240" aria-hidden="true" focusable="false">
            <path class="g-body" d="${g.body}"/>
            <path class="g-line" d="${g.lines}"/>
          </svg>
          ${withPrint && TS.logoCard ? `<img class="garment__print" src="${TS.logoCard}" alt="" loading="lazy" width="320" height="480"
            style="--px:${p.px};--py:${p.py};--pw:${p.pw}">` : ''}
        </div>
      </div>`;
  }
  document.body.insertAdjacentHTML('afterbegin', `
    <svg width="0" height="0" style="position:absolute" aria-hidden="true">
      <defs>
        <linearGradient id="garmentFill" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stop-color="#1e1e1e"/><stop offset=".55" stop-color="#101010"/><stop offset="1" stop-color="#2a2a2a"/>
        </linearGradient>
      </defs>
    </svg>`);
  $$('[data-garment]').forEach((el) => { el.innerHTML = garmentHTML(el.dataset.garment); });

  /* ---------- Toast ---------- */
  const toastEl = $('#toast');
  function toast(msg, ok = true) {
    if (!toastEl) return;
    toastEl.innerHTML = `${ok ? '<svg class="icon" aria-hidden="true"><use href="#i-check"/></svg>' : ''}${esc(msg)}`;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 3200);
  }

  /* ---------- Cart (Shopify AJAX API) ---------- */
  const R = TS.routes;
  const cartJSON = (path, body) => fetch(`${path}.js`, body ? {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  } : { headers: { Accept: 'application/json' } }).then(async (r) => {
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'Something went wrong');
    return data;
  });

  /* Free US shipping progress (threshold in cents comes from the layout) */
  function renderFreeShip(total) {
    const el = $('#cartShip');
    const goal = TS.freeShipping || 0;
    if (!el || !goal) return;
    const left = Math.max(0, goal - total);
    el.querySelector('[data-ship-text]').textContent = left > 0
      ? `You're ${money(left)} away from free US shipping`
      : 'Your order ships free in the US';
    el.querySelector('[data-ship-bar]').style.transform = `scaleX(${Math.min(1, total / goal)})`;
    el.classList.toggle('is-done', left === 0);
  }

  function renderCart(cart, bump = false) {
    const count = cart.item_count;
    const badge = $('#cartCount');
    if (badge) {
      badge.textContent = count;
      badge.classList.toggle('is-empty', count === 0);
      if (bump) { badge.classList.remove('bump'); void badge.offsetWidth; badge.classList.add('bump'); }
    }
    const label = $('#cartLabel');
    if (label) label.textContent = `Cart, ${count} ${count === 1 ? 'item' : 'items'}`;

    $('#cartList').innerHTML = cart.items.map((item, i) => {
      const img = item.featured_image && item.featured_image.url
        ? `<img src="${item.featured_image.url}${item.featured_image.url.includes('?') ? '&' : '?'}width=200" alt="" loading="lazy">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? esc(item.variant_title) : '';
      return `
        <li class="cart-item" data-line="${i + 1}">
          <a href="${item.url}" class="cart-item__thumb" tabindex="-1" aria-hidden="true">${img}</a>
          <div>
            <p class="cart-item__name"><a href="${item.url}">${esc(item.product_title)}</a></p>
            ${variant ? `<p class="cart-item__size">${variant}</p>` : ''}
            <div class="qty" role="group" aria-label="Quantity for ${esc(item.product_title)}">
              <button type="button" data-qty="${item.quantity - 1}" aria-label="Decrease quantity"><svg class="icon"><use href="#i-minus"/></svg></button>
              <span>${item.quantity}</span>
              <button type="button" data-qty="${item.quantity + 1}" aria-label="Increase quantity"><svg class="icon"><use href="#i-plus"/></svg></button>
            </div>
          </div>
          <div>
            <p class="cart-item__price">${money(item.final_line_price)}</p>
            <button type="button" class="cart-item__remove" data-qty="0">Remove</button>
          </div>
        </li>`;
    }).join('');

    $('#cartSubtotal').textContent = money(cart.total_price);
    renderFreeShip(cart.total_price);
    $('#cartEmpty').classList.toggle('is-visible', count === 0);
    $('#cartFoot').hidden = count === 0;
  }

  const refreshCart = (bump) => cartJSON(R.cart).then((c) => renderCart(c, bump)).catch(() => {});

  $('#cartList')?.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const li = btn.closest('.cart-item');
    li.classList.add('is-busy');
    cartJSON(R.cartChange, { line: +li.dataset.line, quantity: Math.max(0, +btn.dataset.qty) })
      .then((c) => { renderCart(c); if (+btn.dataset.qty === 0) $('#cartTitle')?.focus(); })
      .catch((err) => { li.classList.remove('is-busy'); toast(err.message, false); });
  });

  /* Product cards: pick the variant that matches the chosen size */
  $$('[data-product-card]').forEach((card) => {
    const variants = JSON.parse(card.querySelector('[data-variants]')?.textContent || '[]');
    const sizeIndex = +card.dataset.sizeIndex;
    const btn = card.querySelector('[data-add]');
    const label = btn?.querySelector('span');

    function selectedVariant() {
      if (sizeIndex < 0) return variants.find((v) => v.available) || null;
      const size = card.querySelector('.sizes input:checked')?.value;
      return variants.find((v) => v.available && v.options[sizeIndex] === size) || null;
    }

    btn?.addEventListener('click', () => {
      const v = selectedVariant();
      if (!v) { toast('Please choose an available size', false); return; }
      btn.classList.add('is-loading');
      cartJSON(R.cartAdd, { items: [{ id: v.id, quantity: 1 }] })
        .then(() => cartJSON(R.cart))
        .then((c) => {
          renderCart(c, true);
          btn.classList.add('is-added'); label.textContent = 'Added';
          clearTimeout(btn._t);
          btn._t = setTimeout(() => { btn.classList.remove('is-added'); label.textContent = 'Add to Cart'; }, 1400);
          const size = sizeIndex >= 0 ? ` (${v.options[sizeIndex]})` : '';
          toast(`${card.dataset.title}${size} added`);
        })
        .catch((err) => toast(err.message, false))
        .finally(() => btn.classList.remove('is-loading'));
    });
  });

  /* ---------- Overlays (cart, menu, search) ---------- */
  let lastFocus = null;
  function openLayer(layer, trigger) {
    lastFocus = trigger || document.activeElement;
    layer.classList.add('is-open');
    layer.setAttribute('aria-hidden', 'false');
    trigger?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    const target = layer.querySelector('input[type="search"], [data-close].icon-btn, button, a');
    setTimeout(() => target?.focus(), 50);
  }
  function closeLayer(layer) {
    layer.classList.remove('is-open');
    layer.setAttribute('aria-hidden', 'true');
    $$(`[aria-controls="${layer.id}"]`).forEach((t) => t.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = '';
    lastFocus?.focus();
  }
  [$('#cart'), $('#mobileNav'), $('#search')].filter(Boolean).forEach((layer) => {
    layer.addEventListener('click', (e) => { if (e.target.closest('[data-close]')) closeLayer(layer); });
    layer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeLayer(layer);
      if (e.key === 'Tab') {
        const f = $$('a[href], button:not([disabled]), input:not([type="hidden"])', layer).filter((el) => el.offsetParent !== null);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f.at(-1).focus(); }
        else if (!e.shiftKey && document.activeElement === f.at(-1)) { e.preventDefault(); f[0].focus(); }
      }
    });
  });
  $('#cartOpen')?.addEventListener('click', (e) => { openLayer($('#cart'), e.currentTarget); refreshCart(); });
  $('#menuOpen')?.addEventListener('click', (e) => openLayer($('#mobileNav'), e.currentTarget));
  $('#searchOpen')?.addEventListener('click', (e) => openLayer($('#search'), e.currentTarget));

  /* ---------- Predictive search ---------- */
  const searchInput = $('#searchInput');
  const searchResults = $('#searchResults');
  let searchTimer;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    if (!q) { searchResults.innerHTML = ''; return; }
    searchTimer = setTimeout(() => {
      const url = `${R.predictiveSearch}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
      fetch(url).then((r) => r.json()).then((data) => {
        const items = data?.resources?.results?.products || [];
        const all = `<a href="${R.search}?type=product&q=${encodeURIComponent(q)}" class="search__all">See all results for &ldquo;${esc(q)}&rdquo;</a>`;
        searchResults.innerHTML = items.length
          ? items.map((p) => `<a href="${p.url}">${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : ''}<span>${esc(p.title)}</span><span>${esc(p.price ? money(Math.round(parseFloat(p.price) * 100)) : '')}</span></a>`).join('') + all
          : `<p>No results for &ldquo;${esc(q)}&rdquo;. Try &ldquo;hoodie&rdquo; or &ldquo;tee&rdquo;.</p>`;
      }).catch(() => {});
    }, 220);
  });

  /* ---------- Newsletter (Shopify customer form) ---------- */
  const form = $('#newsForm');
  const email = $('#email');
  const msg = $('#emailMsg');
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function setMsg(text, type) { msg.textContent = text; msg.className = 'field__msg' + (type ? ' is-' + type : ''); }
  form?.addEventListener('submit', (e) => {
    const v = email.value.trim();
    if (!v || !EMAIL_RE.test(v)) {
      e.preventDefault();
      email.setAttribute('aria-invalid', 'true');
      setMsg(!v ? 'Enter your email address to join.' : 'That email looks incomplete. Check for a typo, like a missing "@" or ".com".', 'error');
      email.focus();
      return;
    }
    email.removeAttribute('aria-invalid');
    form.querySelector('button[type="submit"]').disabled = true;
  });
  email?.addEventListener('blur', () => {
    if (email.getAttribute('aria-invalid') && EMAIL_RE.test(email.value.trim())) { email.removeAttribute('aria-invalid'); setMsg(''); }
  });
  if (msg && msg.classList.contains('is-success')) {
    $('#newsletter')?.scrollIntoView({ block: 'center' });
  }

  /* ---------- Hero video ----------
     Plays the clean middle of the clip (skipping its fades to black) and
     crossfades two stacked <video>s at the loop point. */
  (() => {
    const hero = $('.hero');
    const vids = $$('.hero__video');
    const toggle = $('#heroMotion');
    if (!hero || vids.length < 2) return;

    const small = matchMedia('(max-width: 900px)').matches || navigator.connection?.saveData;
    const src = (small && hero.dataset.videoMobile) || hero.dataset.videoDesktop;
    if (!src) { toggle?.remove(); return; }
    const start = parseFloat(hero.dataset.videoStart) || 0;
    const FADE = 1.2;
    let end = parseFloat(hero.dataset.videoEnd) || 0;

    let front = 0, fading = false, userPaused = false, inView = true;
    vids.forEach((v) => { v.src = src; v.muted = true; });
    const active = () => vids[front];

    function setIcon() {
      toggle.setAttribute('aria-pressed', String(userPaused));
      toggle.setAttribute('aria-label', userPaused ? 'Play background video' : 'Pause background video');
      toggle.querySelector('use').setAttribute('href', userPaused ? '#i-play' : '#i-pause');
    }

    async function begin() {
      const v = active();
      if (v.readyState < 1) await new Promise((r) => v.addEventListener('loadedmetadata', r, { once: true }));
      if (!end || end > v.duration) end = v.duration - 0.3;
      v.currentTime = start;
      v.addEventListener('playing', () => v.classList.add('is-visible'), { once: true });
      if (!userPaused && inView) v.play().catch(() => {});
    }

    function crossfade() {
      fading = true;
      const cur = active();
      const next = vids[1 - front];
      next.currentTime = start;
      next.play().then(() => {
        next.classList.add('is-front');
        cur.classList.remove('is-front');
        next.classList.add('is-visible');
        setTimeout(() => {
          cur.pause();
          cur.classList.remove('is-visible');
          front = 1 - front;
          fading = false;
        }, FADE * 1000 + 50);
      }).catch(() => { fading = false; });
    }

    (function tick() {
      const v = active();
      if (!fading && end && !v.paused && v.currentTime >= end - FADE) crossfade();
      requestAnimationFrame(tick);
    })();

    function sync() {
      const shouldPlay = !userPaused && inView && !document.hidden;
      vids.forEach((v) => {
        if (shouldPlay && v.classList.contains('is-visible')) v.play().catch(() => {});
        else v.pause();
      });
      if (shouldPlay && active().paused) active().play().catch(() => {});
    }

    toggle?.addEventListener('click', () => { userPaused = !userPaused; setIcon(); sync(); });
    document.addEventListener('visibilitychange', sync);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => { inView = e.isIntersecting; sync(); }).observe(hero);
    }
    setIcon();
    begin();
  })();

  /* ---------- Header state ---------- */
  const header = $('#header');
  const onScroll = () => header?.classList.toggle('is-scrolled', window.scrollY > 8);
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---------- Reveal on scroll ---------- */
  const reveals = $$('.reveal');
  $$('.hero:not(.hero--v2) .reveal').forEach((el, i) => el.style.setProperty('--d', `${i * 90}ms`));
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  refreshCart();
})();
